import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, InputLabel } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import BannerImage from "../../../Images/TealEvaluationform.png";
import Paper from "@material-ui/core/Paper";
import DataService from "../../../Service";
import CustomInput from "../../../Components/CustomInput";
import { useHistory, useParams } from "react-router-dom";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import CustomRating from "../../../Components/customRating";
import StarIcon from "@material-ui/icons/Star";
import Fab from "@material-ui/core/Fab";
import { CircularProgress } from "@material-ui/core";

// import MenuItem from "@material-ui/core/MenuItem";

import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  // root: {
  //   flexGrow: 1,
  // },
  root1: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(10),
  },
  bannerStyle: {
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1301,
    position: "sticky",
  },
  stepperButtons: {
    position: "fixed",
    display: "flex",
    justifyContent: "space-between",
    bottom: "3%",
    backgroundColor: "white",
    padding: "10px 0px 20px 0px",
    zIndex: 1,
  },
}));
export const labels = {
  0.5: "Useless",
  1: "Useless+",
  1.5: "Poor",
  2: "Poor+",
  2.5: "Ok",
  3: "Ok+",
  3.5: "Good",
  4: "Good+",
  4.5: "Excellent",
  5: "Excellent+",
};
export default function CustomizedTabs() {
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const [EvaluationForm, setEvaluationForm] = useState([]);
  const dispatch = useDispatch();
  const sessionStorage = window.sessionStorage.getItem("slug");
  const [userData, setUserData] = useState({});
  const [ratingValue, setRatimgValue] = React.useState("");
  const [selectedRating, setSelecetdRating] = React.useState("");
  const [orgLogo, setOrgLogo] = useState("");
  const [assignmentId, setAssignmentId] = useState("");
  const [evaluationId, setEvaluationId] = useState("");
  const [evaluationFieldId, setEvaluationFieldId] = useState("");
  const [prgName, setPrgName] = useState("");
  let { slug } = useParams();
  const [answerData, setAnswerData] = useState({});
  const [evaluationDescription, setEvaluationDescription] = useState("");
  const setInputState = (inputStateValue, inputId) => {
    // setEvaluationFieldId(inputId)
    setAnswerData({ ...answerData, [inputId]: inputStateValue });
    // setUserData({ ...userData, [inputId]: inputStateValue });
  };
  const setRatingState = (selectedItemValue, inputId) => {
    setSelecetdRating(selectedItemValue);
    setEvaluationFieldId(inputId);

    setUserData({ ...userData, [inputId]: selectedItemValue });
  };

  const CrfFetch = () => {
    DataService.getDirectData(`/evaluation_forms/${slug}`).then((res) => {
      setEvaluationId(res.evaluation_form.id);
      setAssignmentId(res.evaluation_form.assignment_id);
      let prgName = res.evaluation_form.programme_name;
      setPrgName(prgName);
      let orgLogo = res.evaluation_form.org_logo;
      setOrgLogo(orgLogo);
      let description = res.evaluation_form.description;
      setEvaluationDescription(description);
      let EvaluationForms = res.evaluation_form.evaluation_form_fields;
      setEvaluationForm(EvaluationForms);
      localStorage.clear();
    });
  };
  const getStar = () => {
    let params = {
      evaluation_form_field_id: evaluationFieldId,
      rating: selectedRating,
    };

    DataService.getDirectData(`/evaluation_forms/get_star_rating`, params).then(
      (res) => {
        if (res.rating_value) {
          setRatimgValue(res.rating_value);
        }
      }
    );
  };

  const handleSubmit = () => {
    let quesArr = [];
    setLoading(true);

    quesArr.length = 0;
    if (
      Object.entries(answerData).length === 0 &&
      answerData.constructor === Object
    ) {
      for (var i in userData) {
        quesArr.push({
          evaluation_form_field_id: i,
          number_of_star: userData[i],
        });
      }
    } else if (userData === undefined) {
      for (var j in answerData) {
        quesArr.push({ evaluation_form_field_id: j, value: answerData[j] });
      }
    } else {
      // console.log("in third condition ", "answer");
      // console.log(
      //   " [...ß ",
      //   [...[Object.keys(answerData) || []], ...[Object.keys(userData) || []]],
      //   "answer from third cond "
      // );

      Object.keys(answerData || []).forEach((item) => {
        quesArr.push({
          evaluation_form_field_id: item,
          value: answerData[item],
        });
      });

      Object.keys(userData || []).forEach((item) => {
        const aswerData = quesArr.find(
          (ans) => ans.evaluation_form_field_id === item
        );
        const index = quesArr.findIndex((item) => {
          return (
            item.evaluation_form_field_id ===
            aswerData?.evaluation_form_field_id
          );
        });
        if (aswerData) {
          quesArr[index] = { ...aswerData, number_of_star: userData[item] };
        } else {
          quesArr.push({
            evaluation_form_field_id: item,
            number_of_star: userData[item],
          });
        }
      });
    }

    const statusData = {
      evaluation_form_id: evaluationId,
      assignment_id: assignmentId,
      evaluation_answers: JSON.stringify(quesArr),
      submitted_at: "true",
    };
    DataService.createData(statusData, "evaluation_answers")
      .then((res) => {
        CrfFetch();
        // console.log(res);
        // console.log(
        //   res.evaluation_form.evaluation_form_fields.filter(
        //     (e) => e.question_name === "Name of Coach"
        //   )[0].answer
        // );
        const nameOfCoach = res.evaluation_form.evaluation_form_fields.filter(
          (e) => e.question_name === "Name of Coach"
        )[0].answer;
        history.push({
          pathname: `/evaluationacknowledgement`,
          state: { nameOfCoach: nameOfCoach },
        });
        setLoading(false);
        dispatch(showSnackbar("success", ["Success!"]));
      })
      .catch((err) => {
        setLoading(false);
        dispatch(showSnackbar("error", [["" + err.errors]]));
      });
  };
  useEffect(() => {
    // setLoading(true);
    CrfFetch();
  }, []);
  useEffect(() => {
    // setLoading(true);
    getStar();
  }, [selectedRating]);

  return (
    <div>
      {/* <img
        src={BannerImage}
        className={classes.bannerStyle}
        alt={BannerImage}
        width="100%"
      /> */}
      <div class="parent">
        <img
          src={BannerImage}
          class="image1"
          // className={classes.bannerStyle}
          alt={BannerImage}
          width="100%"
        />
        <img class="image2" src={orgLogo && orgLogo?.document?.url} alt="logo" />
        <span class="image4">Program Name - {prgName}</span>
      </div>

      <div className={classes.root}>
        <Paper style={{ padding: "25px" }} elevation={1}>
        {/* <div className={classes.demo1}> */}
            <div class="" style={{ fontSize:"20px" }}>
              {evaluationDescription}
            </div>
          {EvaluationForm.length > 0 &&
            EvaluationForm.map((row, index) => (
              <Grid
                container
                direction="row"
                alignItems="flex-start"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={12}>
                  <InputLabel
                    className={classes.labelText}
                    style={{
                      marginTop: "20px",
                      marginBottom: "20px",
                      fontSize: "18px",
                      color: "black",
                    }}
                  >
                    {row.question_name}
                  </InputLabel>
                </Grid>
                {row.question_type === "rating" && (
                  //                     <Rating
                  //                     style={{
                  //                         marginBottom: "20px",
                  //                     }}
                  //   name="simple-controlled"
                  //   defaultValue={row.number_of_star}
                  //   id={row.id}
                  //   parentcall={setInputState}
                  // />
                  <React.Fragment>
                    <CustomRating
                      // value={value}
                      precision={1}
                      id={row.evaluation_form_field_id}
                      parentcall={setRatingState}
                      // onChange={(event, newValue) => {
                      //   setValue(newValue);
                      // }}
                      defaultValue={""}
                      // value={rating || row?.number_of_star || ''}

                      // onChange={(event,value) => {
                      //   setRatingState(value);
                      // }}
                      // onChange={(e)=>{setRatingState(e.target.value,row.evaluation_form_id);setEvaluationFieldId(row.evaluation_form_field_id)}}
                      // onChangeActive={(event, newHover) => {
                      //   setHover(newHover);
                      // }}
                      emptyIcon={
                        <StarIcon
                          style={{ opacity: 0.55 }}
                          fontSize="inherit"
                        />
                      }
                    />
                    {/* {value !== null && (
<Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : value]}</Box>
)} */}
                  </React.Fragment>
                )}
                <Grid item xs={12}>
                  {evaluationFieldId === row.evaluation_form_field_id &&
                  selectedRating
                    ? ratingValue
                    : ""}
                </Grid>
                <br /> <br />
                <Grid
                  item
                  style={{
                    paddingTop:
                      row.question_type === "text_area" ||
                      row.question_type === "Text area"
                        ? "20px"
                        : "",
                  }}
                  xs={12}
                >
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    style={{ marginBottom: 20 }}
                  >
                    <Grid item xs={12}>
                      {row.question_type === "rating" && (
                        <CustomInput
                          defaultValue={row.answer}
                          id={row.evaluation_form_field_id}
                          variant="outlined"
                          placeholder="Comments"
                          parentcall={setInputState}
                        />
                      )}

                      {row.question_type === "Q/A" && (
                        <CustomInput
                          multiline
                          rows="4"
                          id={row.evaluation_form_field_id}
                          defaultValue={row.answer}
                          placeholder="Answer"
                          //   id={crf_answers}
                          variant="outlined"
                          parentcall={setInputState}
                        />
                      )}
                      {row.question_type === "text" && (
                        <CustomInput
                          multiline
                          rows="4"
                          id={row.evaluation_form_field_id}
                          defaultValue={row.answer}
                          placeholder="Answer"
                          //   id={crf_answers}
                          variant="outlined"
                          parentcall={setInputState}
                        />
                      )}
                      {/* {(row.question_type === "dropdown" || row.question_type === "Drop down") && (
                                                   
                                          <Select
                                            helperText="Please select Location"
                                            variant="outlined"
                                            id={row.id}
                                            defaultValue={row.answer}
                                            onChange={(e)=>setQuestionChangeState(e.target.value,row.id)}
                                            // onChange={setQuestionChangeState}
                                            style={{ width: "100%" }}
                                            inputProps={{
                                              id: "outlined-age-native-simple",
                                            }}
                                          >
                                          {row.question_name === 'Programme Name' ? CoachinRates.map(base=><MenuItem key={base.id} value={base.name}>
                                            {base.name}
                                        </MenuItem>) : row.dropdown_values && row.dropdown_values.map(base=><MenuItem key={base} value={base}>
                                            {base}
                                        </MenuItem>)}
                                          </Select>
                                        )} */}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={0}></Grid>
                <Grid item xs={2}></Grid>
              </Grid>
            ))}
          <Grid container direction="row" alignItems="flex-start">
            <Grid item xs={10}></Grid>
            <Grid item xs={2}>
              <div className={classes.stepperButtons}>
                <Button
                  disableElevation
                  disabled={loading}
                  variant="contained"
                  color="primary"
                  className={classes.btnSearch}
                  onClick={handleSubmit}
                >
                  {loading && (
                    <CircularProgress
                      className={classes.circularProgress}
                      size={20}
                    />
                  )}
                  {"Submit"}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </div>
    </div>
  );
}
